import {
  JUNOON_CAPITAL_LENDER_ID,
  REFYNE_FINANCE_LENDER_ID,
  SUNITA_FINANCE_LENDER_ID,
} from "../../constants";

/*
 INFO: In some reports computations will become convenient since there is no need to compute data for the earlier months where business was not set up.
 Example, month on month disbursal report, for RFL, the report should start from the month of Aug 2024 since that's when business started.

 If we have a static date, then for RFL, disbursal for the months from Apr 2021 to Jul 2024 will be 0 which does not look good. 
*/
export default function getStartDateForLender(lenderId: string | undefined) {
  if (!lenderId) return "";
  if (lenderId === REFYNE_FINANCE_LENDER_ID) return "2024-08-01";
  if (lenderId === SUNITA_FINANCE_LENDER_ID) return "2021-04-01";
  if (lenderId === JUNOON_CAPITAL_LENDER_ID) return "2024-06-01";
  return "";
}

export function formatString(context: {
  inputString?: string;
  customStringValue?: string;
}): string {
  const { inputString, customStringValue } = context;
  if (customStringValue) {
    return customStringValue;
  }
  if (!inputString) return "";

  return inputString
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
